import { useCallback, useEffect, useState } from 'react'

const LOCAL_STORAGE_SYNC_EVENT = 'localStorageSync'

export function useLocalStorage(key, fallback?: any, conversionFunc?: any) {
  const [storageItem, setStorageItemState] = useState(() => {
    const val = localStorage.getItem(key)
    const result = conversionFunc && val !== null ? conversionFunc(val) : val
    if (result === null || result === undefined) return fallback
    try {
      if (typeof result === 'string' && (result.startsWith('[') || result.startsWith('{'))) {
        return JSON.parse(result)
      }
    } catch {
      // something happened, that shouldnt have happened,  reset
    }
    return result
  })

  const setStorageItem = useCallback(
    (value: any) => {
      setStorageItemState(value)
      const valToStore = typeof value === 'object' && value !== null ? JSON.stringify(value) : value
      if (valToStore !== null && valToStore !== undefined) {
        localStorage.setItem(key, valToStore)
        window.dispatchEvent(new CustomEvent(LOCAL_STORAGE_SYNC_EVENT, { detail: { key, value: valToStore } }))
      }
    },
    [key],
  )

  useEffect(() => {
    const handler = (e: CustomEvent<{ key: string; value: string }>) => {
      if (e.detail.key !== key) return
      try {
        const parsed = JSON.parse(e.detail.value)
        setStorageItemState(parsed)
      } catch {
        setStorageItemState(e.detail.value)
      }
    }
    window.addEventListener(LOCAL_STORAGE_SYNC_EVENT as any, handler)
    return () => window.removeEventListener(LOCAL_STORAGE_SYNC_EVENT as any, handler)
  }, [key])

  return [storageItem, setStorageItem]
}
